import { Card, TruncateText } from '@mint-lib/tw-components';

import { getFolderIcon } from '../../../../helpers/knowledge-base/getFolderIcon.js';
import type { FolderNode } from '../../../../types/fileSystem.js';
import { FileIcon } from '../FileIcon/FileIcon.jsx';

type NavigationFolderItemProps = {
  folder: FolderNode;
  onOpen?: (folder: FolderNode) => void;
};

const NavigationFolderItem = ({
  folder,
  onOpen,
}: NavigationFolderItemProps) => {
  return (
    <Card
      variant="outlined"
      className="w-full"
      contentClassName="flex flex-row gap-2 items-center justify-start p-2"
      data-dd-action-name="Knowledge base: open navigation folder"
      onDoubleClick={() => onOpen?.(folder)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onOpen?.(folder);
        }
      }}
    >
      <FileIcon type={getFolderIcon(folder)} />
      <TruncateText>{folder.name}</TruncateText>
    </Card>
  );
};

export { NavigationFolderItem };
